export default class WIOwnership {
    id: number;
    projectId: number;
    ownerLookUpId: number;
    parentOwnershipId: number;
    decimalInterest: number;
    ownershipId: number;
    leaseholdId: number;
    note: string;
    orriOwnerships: Array<WIOwnership>;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/WIOwnership.ts